import axiosInstance from '../utils/axios-instance';
import { actionCreator, createRequestTypes } from '../utils/helpers';


export const FETCH_LINKED_ACCOUNTS_BEGIN = 'FETCH_LINKED_ACCOUNTS_BEGIN';
export const FETCH_LINKED_ACCOUNTS_SUCCESS = 'FETCH_LINKED_ACCOUNTS_SUCCESS';
export const FETCH_LINKED_ACCOUNTS_FAILURE = 'FETCH_LINKED_ACCOUNTS_FAILURE';
export const TOGGLE_IS_ACTIVE = 'TOGGLE_ACTIVE_STATE';
export const FETCH_LINKED_USERS_BEGIN = 'FETCH_LINKED_USERS_BEGIN';
export const FETCH_LINKED_USERS_SUCCESS = 'FETCH_LINKED_USERS_SUCCESS';
export const FETCH_LINKED_USERS_FAILURE = 'FETCH_LINKED_USERS_FAILURE';



export const unlinkCurrentUserFromAccount = async (accountId, unregisteredBySystemUserId, userId) => {
    const payload = {
        "accountId": accountId,
        "unregisteredBySystemUserId": unregisteredBySystemUserId,
        "userId": userId
    };
    try {
        const response = await axiosInstance.post(`linked-accounts/unlink-current-user-from-account`, payload);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const linkUserToAccount = async (accountNumber, contactEmail, userId) => {
    const payload = {
        "accountNumber": accountNumber,
        "contactEmailAddress": contactEmail,
        "requestedUserId": userId
    };
    try {
        const response = await axiosInstance.post(`/linked-accounts/request-link-user-to-account`, payload);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const fetchLinkedAccountsBegin = () => ({
    type: FETCH_LINKED_ACCOUNTS_BEGIN
});

export const fetchLinkedAccountsSuccess = accounts => ({
    type: FETCH_LINKED_ACCOUNTS_SUCCESS,
    payload: { accounts }
});

export const fetchLinkedAccountsFailure = error => ({
    type: FETCH_LINKED_ACCOUNTS_FAILURE,
    payload: { error }
});

export function toggleIsActive(isActive) {
    return {
        type: TOGGLE_IS_ACTIVE,
        payload: isActive,
    };
}


export const fetchLinkedAccounts = (userId) => {
    return dispatch => {
        dispatch(fetchLinkedAccountsBegin());

        return axiosInstance.get(`/linked-accounts/by-user/${userId}`)
            .then(res => {
                dispatch(fetchLinkedAccountsSuccess(res.data));
                return res.data;
            })
            .catch(error => dispatch(fetchLinkedAccountsFailure(error)));
    };
}

export const fetchLinkedUsersBegin = () => ({
    type: FETCH_LINKED_USERS_BEGIN
});

export const fetchLinkedUsersSuccess = users => ({
    type: FETCH_LINKED_USERS_SUCCESS,
    payload: { users }
});

export const fetchLinkedUsersFailure = error => ({
    type: FETCH_LINKED_USERS_FAILURE,
    payload: { error }
});

export const fetchLinkedUsers = (accountId) => {
    return dispatch => {
        dispatch(fetchLinkedUsersBegin());
        return axiosInstance.get(`/linked-accounts/by-account/${accountId}`)
            .then(res => {
                dispatch(fetchLinkedUsersSuccess(res.data));
                return res.data;
            })
            .catch(error => dispatch(fetchLinkedUsersFailure(error)));
    };
}

